export default __webpack_public_path__ + "static/media/Bones_sm.61a6a1df.jpg";